import { INeoAction } from './../Actions.interface';
import { isActionValid } from '../../Helpers/Reducer.helper';
import { STATUS, REQUEST_ACTIONS } from '../../Constants/Actions.constants';
import { ITrainer } from '../../Models/DTO/Trainer.models';

const useValidActions = isActionValid([REQUEST_ACTIONS.TRAINER_LIST]);

export default (state: ITrainer[] = [], action: INeoAction) => {
  const { name, status, payload } = action;

  const actionValid = useValidActions(name);

  if (isActionValid([REQUEST_ACTIONS.GET_PROVIDER])(name)) {
    if (status === STATUS.SUCCESS) {
      return [];
    }
  }
  if (actionValid) {
    if (status === STATUS.SUCCESS) {
      const trainers = (payload || []) as ITrainer[];
      return trainers.map((trainer) => ({
        ...trainer,
        name:
          trainer.firstName && trainer.lastName
            ? `${trainer.firstName} ${trainer.lastName}`
            : trainer.firstName || trainer.lastName,
      }));
    }
  }

  return state;
};
